import {Module} from "vuex";
import {IData} from "@/types/globalTypes";

interface IError{
    // type: string;
    // key: string;
    message: string;
    // stack: string;
    // browser: string;
    // uri: string;
    // params: IData;
    response?: IData;
}
interface IErrorState{
    name: string;
    message: string;
    // fn: string;
    // uri: string;
    // params: IData;
    // key: string;
}
export default <Module<IErrorState, any>>{
    state:{
        name: '',
        message: '',
        // fn:'',
        // uri:'',
        // params:{},
        // key:'',
    },
    mutations:{
        setError(state, {message='', response}:IError=<IError>{}) {
            if (response) {
                switch(response.status) {
                    case 500:
                        state.name = 'Внутренняя ошибка сервера';
                        break;
                    case 502:
                        state.name = 'Сервер временно недоступен';
                        state.message = 'Ошибка 502. Обновите позже.';
                        return;
                    case 401:
                        return;
                    case 423:
                        return;
                    default:
                        state.name = 'Ошибка';
                }
                if (response.data){
                    if (response.data.message)
                        state.message = response.data.message;
                    else if (response.data.errorMessage)
                        state.message = response.data.errorMessage;
                    else if (typeof response.data === 'string')
                        state.message = response.data;
                    else
                        state.message = message;
                }
                else
                    state.message = message;
            }
            else {
                state.message = message;
                state.name = 'Ошибка клиента';
            }
        },
        clearError(state) {
            state.name = '';
            state.message = '';
        },
    },
    actions:{
        setError({commit, dispatch}, e){
            const erorrIncludes = [401, 409, 423];
            if (('response' in e) && erorrIncludes.includes(e.response.status)) return;
            dispatch('setLoader'); // Если был лоадер, а возникла ошибка, к ней не попасть
            commit('setError', e);
        },
    },
    getters:{
        error: (state):IErrorState => state,
    },
};